export default "<div class=\"container clearfix\">\n<router-outlet></router-outlet>\n</div>\n";